import React, { useState } from "react";

import Image from "../elements/Image";
import card1 from "../../assets/images/visacard.png";
import card2 from "../../assets/images/mastercard.png";
import card3 from "../../assets/images/ameriacnexpress.png";
import card4 from "../../assets/images/disovernetworkcard.png";
import Input from "../form/Input";
import Select from "../form/Select";
import Button from "../form/Button";
import { country } from "../../helpers";
import { classNames } from "../../helpers/classNames";

const PaymentMethodData = {
  heading: "Payment Information",
  subheading: "Payment <span class='text-red-600 font-extrabold'>Details</span>",
  title: "Amount being paid now:",
  price: "Cad 115.5",
};

const PaymentMethod = ({ onPlaceOrder = () => {}, loaded, setLoaded = () => {}, myCartList, myCheckoutData, data }) => {
  const orderSummaryData = {
    cartSummary: myCheckoutData && myCheckoutData?.cartSummary && myCheckoutData?.cartSummary,
    orderSummary: myCheckoutData && myCheckoutData?.orderSummary && myCheckoutData?.orderSummary,
  };

  return (
    <>
      <div className="xl:w-3/5 md:px-0 px-5">
        <div
          className=" uppercase text-black md:text-2xl text-xl font-medium rounded-md md:pt-7 pt-2 md:pb-3 pb-1"
          dangerouslySetInnerHTML={{ __html: PaymentMethodData.subheading }}></div>
        <hr className="w-full border-1 border-slate-500"></hr>
        <div className="flex items-center pt-6">
          <div className="md:text-xl text-base font-semibold text-gray-700 leading-none items-center">
            {PaymentMethodData.title}
          </div>
          <div className="md:text-2xl text-xl font-bold text-red-600 uppercase leading-none pl-2">
            {country + " " + (orderSummaryData?.orderSummary?.totalOrderValue || "0")}
          </div>
        </div>

        <div className="flex space-x-5 mt-2">
          <div
            className={classNames(
              "relative overflow-hidden bg-slate-50 border border-red-600 !shadow-lg rounded-md p-3 z-0"
            )}>
            <div className="flex items-center  md:pb-3 pb-1 space-x-2">
              <div className=" uppercase text-red-600 md:text-2xl text-xl font-medium rounded-md">Shipping Address</div>
            </div>
            <div className="flex items-center">
              <div className="flex-1 space-y-1">
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">Address :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.location || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">City :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.city || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">State :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.stateName || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">Postalcode :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.pin || "-"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex space-x-5 mt-2">
          <div
            className={classNames(
              "relative overflow-hidden bg-slate-50 border border-red-600 !shadow-lg rounded-md p-3 z-0"
            )}>
            <div className="flex items-center  md:pb-3 pb-1 space-x-2">
              <div className=" uppercase text-red-600 md:text-2xl text-xl font-medium rounded-md">Billing Address</div>
            </div>
            <div className="flex items-center">
              <div className="flex-1 space-y-1">
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">Address :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.location || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">City :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.city || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">State :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.stateName || "-"}</div>
                </div>
                <div className="flex flex-wrap items-center md:space-x-2 space-x-1">
                  <div className="text-xs font-bold">Postalcode :</div>
                  <div className="md:text-sm text-xs">{data?.shippingAddress?.pin || "-"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end md:space-x-7 space-x-0 md:pt-16 pt-10">
          <div className=" md:pt-8 pt-2 md:w-auto w-full">
            <Button
              buttonClasses={"bg-gray-600 hover:!bg-black !px-5"}
              buttonLabel="Back to Address"
              buttonLabelClasses="  !text-lg  "
              buttonEffect={"filled"}
              buttonHasLink={true}
              buttonLink={"/checkout"}
            />
          </div>
          {myCartList?.length > 0 && (
            <>
              <div className=" md:pt-8 pt-2 md:w-auto w-full">
                <Button
                  buttonClasses={"!w-full bg-red-600 hover:!bg-black !px-5"}
                  buttonLabel="Place Order"
                  buttonLabelClasses="  !text-lg  "
                  buttonEffect={"filled"}
                  buttonType={"button"}
                  buttonFunction={onPlaceOrder}
                  isDisable={loaded}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentMethod;
